"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The FTH module provides access to the FTH specific call on the EVA back-end
 * @preferred
 */
var service_1 = require("../service");
/**
 * Provides access to a FTH specific functions in EVA
 */
var FTH;
(function (FTH) {
    /**
     * Retrieves the due data for an FTH order
     *
     * @export
     * @param {number} orderID The order to fetch the due date for
     * @returns
     */
    function getOrderDueDate(orderID) {
        // Create the service instance
        //
        var service = new service_1.EVAService("FTHGetDueDateForOrder");
        // Build the request data
        //
        var requestData = {
            OrderID: orderID,
        };
        // Perform the call and return resulting promise
        //
        return service.call(requestData);
    }
    FTH.getOrderDueDate = getOrderDueDate;
    /**
     * Set the due date for an FTH order
     *
     * @export
     * @param {number} orderID The order to set the due date for
     * @param {string} dueDate The due date as an ISO8601 RFC string
     * @returns
     */
    function setOrderDueDate(orderID, dueDate) {
        // Create the service instance
        //
        var service = new service_1.EVAService("FTHSetDueDateOnOrder");
        // Build the request data
        //
        var requestData = {
            OrderID: orderID,
            DueDate: dueDate,
        };
        // Perform the call and return resulting promise
        //
        return service.call(requestData);
    }
    FTH.setOrderDueDate = setOrderDueDate;
    function getFthWishlistDiscount(orderId) {
        var service = new service_1.EVAService("FTHGetWishListDiscount");
        var requestData = {
            OrderID: orderId
        };
        return service.call(requestData);
    }
    FTH.getFthWishlistDiscount = getFthWishlistDiscount;
})(FTH = exports.FTH || (exports.FTH = {}));
